import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { openTermsModal } from '../Store/uiSlice';

// components
// import FirstSection from '../Components/Home/FirstSection';
// import SecondSection from '../Components/Home/SecondSection';
// import ThirdSection from '../Components/Home/ThirdSection';
import HomeHero from '../Components/Home/HomeHero';
import AboutUs from '../Components/Home/AboutUs';
import WasteAndMarket from '../Components/Home/WasteAndMarket';
import MissionAndVision from '../Components/Home/MissionAndVision';
import Slogan from '../Components/Home/Slogan';
import DownloadApp from '../Components/Home/DownloadApp';
import NumbersSlider from '../Components/Home/Numbers';
import ValuesSlider from '../Components/Home/Values';

const Home = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchParams.has('openTermsAndConditions')) {
      dispatch(openTermsModal());
    }
  }, [searchParams]);

  return (
    <section className="home">
      <HomeHero />
      <AboutUs />
      <WasteAndMarket />
      <MissionAndVision />
      <Slogan />
      <NumbersSlider />
      <ValuesSlider />
      <DownloadApp />
    </section>
  );
};

export default Home;
